import { render, staticRenderFns } from "./rootLayout.vue?vue&type=template&id=59537693&scoped=true"
import script from "./rootLayout.vue?vue&type=script&lang=js"
export * from "./rootLayout.vue?vue&type=script&lang=js"
import style0 from "./rootLayout.vue?vue&type=style&index=0&id=59537693&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59537693",
  null
  
)

export default component.exports